import { useId as useReactId } from 'react'

export function useId(prefix: string = '') {
  return prefix + useReactId()
}
